import React from 'react'

import ContactButton from './ContactButton'
import styles from './Navigation.module.css'

export default () => (
  <div className={styles.bg}>
    <div className={styles.container}>
      <span className={styles.logo}>BOWTIE</span>
      {/* <ContactButton
        text="Message us"
        size="small"
      /> */}
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Navigation.js